import { React, useState, useEffect } from "react";

const PopUp32CardResults = ({ resultsData, catMid, marketType }) => {
    const resultData = resultsData;

    useEffect(() => {
        console.log("Market Type:", marketType);
        console.log("Results Data:", resultsData);
    }, [resultsData, marketType]);

    const dataObj = resultsData;


    const formatMarketStartTime = (dateString) => {
        if (!dateString) return "";
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "";
        return date.toLocaleString("en-US", {
            month: "numeric",
            day: "numeric",
            year: "numeric",
            hour: "numeric",
            minute: "2-digit",
            second: "2-digit",
            hour12: true
        });
    };


    let Player8 = "";
    let Player9 = "";
    let Player10 = "";
    let Player11 = "";

    const AndarBaharcards = resultData?.cards_desc?.split(",") || [];
    const andarCards = AndarBaharcards.filter((_, i) => i % 2 === 0);
    const baharCards = AndarBaharcards.filter((_, i) => i % 2 !== 0);


    if (marketType == 18) {
        if (resultData?.result == 1) {
            Player8 = "Winner";
            Player9 = "LOSER";
            Player10 = "LOSER";
            Player11 = "LOSER";
        } else if (resultData?.result == 2) {
            Player8 = "LOSER";
            Player9 = "Winner";
            Player10 = "LOSER";
            Player11 = "LOSER";
        } else if (resultData?.result == 3) {
            Player8 = "LOSER";
            Player9 = "LOSER";
            Player10 = "Winner";
            Player11 = "LOSER";
        } else if (resultData?.result == 4) {
            Player8 = "LOSER";
            Player9 = "LOSER";
            Player10 = "LOSER";
            Player11 = "Winner";
        }
    }

    return (
        <div>
            <div id="ResultsData">
                <div class="left-content site_family">

                    <div id="32-card" style={{ display: marketType == 18 ? "" : "none" }}>
                        <div class="left-content">
                            <div class="card">
                                <div class="card-header">
                                    Market Start Time = {formatMarketStartTime(dataObj.evt_od)}
                                </div>
                                <div class="card-body">
                                    <div className="players-cards-container">
                                        <div className="player-card-section">
                                            <div className="player-card-title">
                                                Player 8
                                            </div>
                                            <div className="player-card-box">
                                                <div className="cards">
                                                    <img
                                                        src={`/assets/images/cards/${AndarBaharcards[0]}.svg`}
                                                        className="img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="player-card-section">
                                            <div className="player-card-title">
                                                Player 9
                                            </div>
                                            <div className="player-card-box">
                                                <div className="cards">
                                                    <img
                                                        src={`/assets/images/cards/${AndarBaharcards[1]}.svg`}
                                                        className="img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="player-card-section">
                                            <div className="player-card-title">
                                                Player 10
                                            </div>
                                            <div className="player-card-box">
                                                <div className="cards">
                                                    <img
                                                        src={`/assets/images/cards/${AndarBaharcards[2]}.svg`}
                                                        className="img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                        <div className="player-card-section">
                                            <div className="player-card-title">
                                                Player 11
                                            </div>
                                            <div className="player-card-box">
                                                <div className="cards">
                                                    <img
                                                        src={`/assets/images/cards/${AndarBaharcards[0]}.svg`}
                                                        className="img"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Player 8
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Player8}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Player 9
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Player9}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Player 10
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Player10}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div>
                                        <div class="market-runners">
                                            <div class="runner-runner">
                                                <h3 class="runner-name">
                                                    <div class="runner-info">
                                                        <span class="clippable runner-display-name">
                                                            <h4
                                                                data-toggle="tooltip"
                                                                data-placement="top"
                                                                data-html="true"
                                                                class="clippable-spacer"
                                                            >
                                                                Player 11
                                                            </h4>
                                                        </span>
                                                    </div>
                                                </h3>
                                                <div class="runner-disabled">{Player11}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
            <style>
                {`
        .players-cards-container {
            width: 100%;
            box-sizing: border-box;
        }
        .player-card-section {
            width: 100%;
            margin-bottom: 5px;
        }
        .player-card-title {
            width: 100%;
            text-align: center;
            font-size: 18px;
            font-weight: 600;
        }
        .player-card-box {
            width: calc(100% - 40px);
            margin: 0 auto;
            border: 1px solid #c8ddc8;
            border-radius: 17px;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 2px;
        }
        .player-card-box .cards {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            margin: 0;
            padding: 0;
        }
        .player-card-box .img {
            display: block;
            width: 50px;
            max-width: 50px;
            height: auto;
            margin: 0;
        }
        .player-card-box .cardsText {
            display: none;
        }
    `}
            </style>
        </div>
    );
};

export default PopUp32CardResults;

